import { Grid } from "@mui/material";
import ChildCard from "@shared-layouts/ChildCard";
import ParentCard from "@shared-layouts/ParentCard";
import { useNavigate } from "react-router-dom";
import { TotalCardWrapper } from "../TotalSales/style";

import LabourCogsTotalTargetShared from "./LabourCogsTotalTargetShared";
import { ChildCardWrapper } from "./style";
import { LABOUR_COGS_TITLE } from "../../helper";

interface LabourCogsProps {
  title: string;
  subTitle: string;
  LabourCogsData: LabourCogsDataTypes;
  hideTarget: boolean;
  loading: boolean;
}

const LabourCogs = (porps: LabourCogsProps) => {
  const { title, LabourCogsData, subTitle, hideTarget, loading } = porps;
  const navigate = useNavigate();

  const handleViewAllButton = () => {
    const dashboardName = subTitle.toLowerCase();
    navigate(`/${dashboardName}-dashboard`);
    return null;
  };

  return (
    <TotalCardWrapper>
      <ParentCard title={title} handleViewAllButton={handleViewAllButton}>
        <ChildCardWrapper onClick={handleViewAllButton}>
          <ChildCard title={subTitle}>
            <Grid style={{ marginTop: 8 }} direction="row" container>
              <LabourCogsTotalTargetShared
                title="Total"
                amount={LabourCogsData?.total_act}
                percentage={LabourCogsData?.total_pct}
                hideTarget={hideTarget}
                loading={loading}
              />
              {!hideTarget && (
                <LabourCogsTotalTargetShared
                  title="Target"
                  amount={LabourCogsData?.target_act}
                  percentage={LabourCogsData?.target_pct}
                  loading={loading}
                  isInteger={LABOUR_COGS_TITLE.COGS === title}
                />
              )}
            </Grid>
          </ChildCard>
        </ChildCardWrapper>
      </ParentCard>
    </TotalCardWrapper>
  );
};

LabourCogs.defaultProps = {
  hideTarget: false,
};

export default LabourCogs;
